import React from 'react';
import {
  Layout,
  SectionHeroBanner,
  SectionAboutBusiness,
  SectionServices,
} from '@websites/components';
import { YellowBusinessContext } from '../contexts/YellowBusinessContext';

const IndexPage = () => {
  const { yellowBusiness, sections } = React.useContext(YellowBusinessContext);

  const hasTheme = !!yellowBusiness?.website?.theme;

  let servicesKeywords = [];
  if (yellowBusiness?.products?.length > 0) {
    servicesKeywords = yellowBusiness?.products?.map((product) => product.name);
  }

  return (
    <>
      {hasTheme && (
        <Layout
          headerTransparent
          keywords={servicesKeywords}
          yellowBusiness={yellowBusiness}
          sections={sections}
        >
          <SectionHeroBanner
            yellowBusiness={yellowBusiness}
          />
          <SectionAboutBusiness
            section={sections.aboutBusinessSection}
            yellowBusiness={yellowBusiness}
          />
          <SectionServices
            section={sections.servicesSection}
            yellowBusiness={yellowBusiness}
          />
        </Layout>
      )}
    </>
  );
};

export default IndexPage;
